// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"f3a77b0b","264":"5327566f","453":"bb53e782","480":"0a369f52","738":"fb7523a6"}[chunkId] + ".chunk.js";
};